<template>
  <div>
    <v-tooltip :key="subscriptionBlock.id" bottom>
      <template v-slot:activator="{ on, attrs }">
        <span class="block" v-bind="attrs" v-on="on"
          >{{ subscriptionBlock.block.title }}
          <br />
          <span v-if="subscriptionBlock.isSelfPaced" class="font-italic">(Self-Paced)<br /></span>
          <b v-if="currentDay">{{ `Day ${currentDay} of ${subscriptionBlock.block.duration}` }}</b>
        </span>
      </template>
      <span class="block">Start date: {{ subscriptionBlock.startDate }} </span>
      <span class="block">End date: {{ subscriptionBlock.endDate }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { DAILY_WORKOUT_ACTIVITIES_QUERY } from "@/graphql/queries/coaching";
import { decodeId } from "@/lib/string";

export default {
  name: "ActiveWorkoutBlock",
  props: {
    subscriptionBlock: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentDay: null,
    };
  },
  apollo: {
    dailyWorkoutActivities: {
      query: DAILY_WORKOUT_ACTIVITIES_QUERY,
      fetchPolicy: "cache-and-network",
      variables() {
        return {
          anchorDate: this.$moment().format("YYYY-MM-DD"),
          subscriptionBlockId: decodeId(this.subscriptionBlock.id),
        };
      },
      result(response) {
        if (response.data) {
          this.currentDay = response.data.dailyWorkoutActivities?.[0].activities?.[0]?.currentDay;
        }
      },
    },
  },
};
</script>
